import {
  CreateMixin,
  CreateRenderFunction,
  NextFrame,
} from "@pdfking/reactivity/preact"
import { apply, contains, first, last, length } from "@pdfking/rfunc"
import { Items, Keys } from "@pdfking/tfunc"
import { IDMixin } from "@pdfking/workflow/mixins/IDMixin"
import { RootMixin } from "@pdfking/workflow/mixins/RootMixin"
import fire_event from "@pdfking/workflow/utils/fire_event"
import cx from "../utils/cx"

const divider = "///"

export const DoubleMixin = CreateMixin({
  computed: {
    is_invalid() {
      return length(this.options_visible) == 0
    },
    label() {
      return last(this.selection.split(divider))
    },
    options_visible() {
      return this.options_for_selection(this.selection)
    },
    placeholder() {
      return this.options_visible[this.current]
    },

    selection: {
      get() {
        return this.find_value(this.current)
      },
      set(value: string) {
        this.current = first(Keys(this.options_for_selection(value)))
      },
    },
    show_second() {
      return length(this.options_visible) >= 1 && first(this.options_visible)
    },
  },
  data: {
    current: "",
  },
  init() {
    this.current = this.value
  },

  methods: {
    find_value(v: string) {
      for (const l in this.options) {
        for (const g in this.options[l]) {
          if (contains(this.options[l][g], v)) {
            return this.make_key(l, g)
          }
        }
      }
      return this.make_key("", "")
    },
    first,

    length,
    make_key: (label: string, selection: string) => label + divider + selection,

    options_for_selection(selection: string) {
      return apply(
        (l: string, g: string) => (this.options[l] ? this.options[l][g] : {}),
        selection.split(divider)
      )
    },
  },
  mixins: [IDMixin, RootMixin],
  props: {
    class: "",
    disabled: false,
    name: "",
    on_selection: null as ((v: string) => void) | null,
    options: {} as Record<string, Record<string, Record<string, string>>>,
    size_1: null as string | null,
    size_2: null as string | null,
    value: "",
  },

  render(children: any) {
    return (
      <div
        class={`${this.show_second ? "input-group" : ""} ${this.class}`}
        onClick={(e: Event) => e.stopPropagation()}
      >
        <select
          class={cx("form-select prevent-submit-onchange", {
            "flex-grow-0": this.show_second && this.size_1,
            "is-invalid": this.is_invalid,
          })}
          disabled={this.disabled}
          onInput={(e: Event) => {
            this.selection = (e.target as HTMLSelectElement).value
          }}
          style={{
            width: this.show_second ? this.size_1 : null,
          }}
          title={this.label}
          value={this.selection}
        >
          {this.is_invalid && (
            <option value={this.selection}>{this.value}</option>
          )}
          {Items(this.options || {}).map(([label, inner]: [string, any]) =>
            label ? (
              <optgroup key={label} label={label}>
                {Keys(inner).map((opt: string) => (
                  <option
                    key={this.make_key(label, opt)}
                    value={this.make_key(label, opt)}
                  >
                    {opt}
                  </option>
                ))}
              </optgroup>
            ) : (
              Keys(inner).map((opt: string) => (
                <option
                  key={this.make_key(label, opt)}
                  value={this.make_key(label, opt)}
                >
                  {opt}
                </option>
              ))
            )
          )}
        </select>
        <input name={this.name} type="hidden" value={this.current} />
        {this.show_second && (
          <select
            class={cx("form-select prevent-submit-onchange", {
              "flex-grow-0": this.size_2,
            })}
            disabled={this.disabled || length(this.options_visible) <= 1}
            onInput={(e: Event) => {
              this.current = (e.target as HTMLSelectElement).value
            }}
            style={{ width: this.size_2 }}
            title={this.placeholder}
            value={this.current}
          >
            <optgroup label={this.label}>
              {Items(this.options_visible).map(([id, title]: [string, any]) => (
                <option key={id} value={id}>
                  {title}
                </option>
              ))}
            </optgroup>
          </select>
        )}
        {children}
      </div>
    )
  },
  watch: {
    current() {
      NextFrame(() =>
        fire_event(this.root?.querySelector("input[type=hidden]"), "change")
      )
      this.on_selection?.(this.current)
    },
  },
})

export const Double = CreateRenderFunction(DoubleMixin)
